// This file was automatically generated from stats.reports.html.
// Please don't edit this file by hand.

goog.provide('el8.template.stats.reports');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.stats.reports.practiceUsage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="row"><div class="span12"><ul class="nav nav-tabs">');
  var stat_recordList32373 = opt_data.data.practice_data;
  var stat_recordListLen32373 = stat_recordList32373.length;
  for (var stat_recordIndex32373 = 0; stat_recordIndex32373 < stat_recordListLen32373; stat_recordIndex32373++) {
    var stat_recordData32373 = stat_recordList32373[stat_recordIndex32373];
    output.append('<li><a href="#', soy.$$escapeHtml(stat_recordData32373.stat), '" class="small">', soy.$$escapeHtml(stat_recordData32373.stat), '</a></li>');
  }
  output.append('</ul></div></div>');
  var stat_recordList32381 = opt_data.data.practice_data;
  var stat_recordListLen32381 = stat_recordList32381.length;
  for (var stat_recordIndex32381 = 0; stat_recordIndex32381 < stat_recordListLen32381; stat_recordIndex32381++) {
    var stat_recordData32381 = stat_recordList32381[stat_recordIndex32381];
    output.append('<div class="row"><div class="span12"><h3>', soy.$$escapeHtml(stat_recordData32381.stat), '<a href="javascript:window.scrollTo(0, 0);" style="font-size: 15px; margin-left: 10px;">top</a></h3><div class="row"><div class="span12"><div id="practice_data_', soy.$$escapeHtml(stat_recordData32381.stat_key), '"></div></div></div><table class="table table-striped table-condensed"><thead><tr><th></th>');
    var dateList32387 = opt_data.data.dates;
    var dateListLen32387 = dateList32387.length;
    for (var dateIndex32387 = 0; dateIndex32387 < dateListLen32387; dateIndex32387++) {
      var dateData32387 = dateList32387[dateIndex32387];
      output.append('<th>', soy.$$escapeHtml(dateData32387), '</th>');
    }
    output.append('</tr></thead><tbody>');
    var practiceList32393 = stat_recordData32381.rows;
    var practiceListLen32393 = practiceList32393.length;
    for (var practiceIndex32393 = 0; practiceIndex32393 < practiceListLen32393; practiceIndex32393++) {
      var practiceData32393 = practiceList32393[practiceIndex32393];
      output.append('<tr><td>', soy.$$escapeHtml(practiceData32393.label), '</td>');
      var valueList32397 = practiceData32393.values;
      var valueListLen32397 = valueList32397.length;
      for (var valueIndex32397 = 0; valueIndex32397 < valueListLen32397; valueIndex32397++) {
        var valueData32397 = valueList32397[valueIndex32397];
        output.append('<td>', soy.$$escapeHtml(valueData32397 ? valueData32397 : '-'), '</td>');
      }
      output.append('</tr>');
    }
    output.append('</tbody></table></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.stats.reports.userUsage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="row"><div class="span12"><ul class="nav nav-tabs">');
  var stat_recordList32408 = opt_data.data.user_data;
  var stat_recordListLen32408 = stat_recordList32408.length;
  for (var stat_recordIndex32408 = 0; stat_recordIndex32408 < stat_recordListLen32408; stat_recordIndex32408++) {
    var stat_recordData32408 = stat_recordList32408[stat_recordIndex32408];
    output.append('<li><a href="#', soy.$$escapeHtml(stat_recordData32408.stat), '" class="small">', soy.$$escapeHtml(stat_recordData32408.stat), '</a></li>');
  }
  output.append('</ul></div></div>');
  var stat_recordList32416 = opt_data.data.user_data;
  var stat_recordListLen32416 = stat_recordList32416.length;
  for (var stat_recordIndex32416 = 0; stat_recordIndex32416 < stat_recordListLen32416; stat_recordIndex32416++) {
    var stat_recordData32416 = stat_recordList32416[stat_recordIndex32416];
    output.append('<div class="row"><div class="span12"><h3>', soy.$$escapeHtml(stat_recordData32416.stat), '<a href="javascript:window.scrollTo(0, 0);" style="font-size: 15px; margin-left: 10px;">top</a></h3><div class="row"><div class="span12"><div id="practice_data_', soy.$$escapeHtml(stat_recordData32416.stat_key), '"></div></div></div><table class="table table-striped table-condensed"><thead><tr><th></th>');
    var dateList32422 = opt_data.data.dates;
    var dateListLen32422 = dateList32422.length;
    for (var dateIndex32422 = 0; dateIndex32422 < dateListLen32422; dateIndex32422++) {
      var dateData32422 = dateList32422[dateIndex32422];
      output.append('<th>', soy.$$escapeHtml(dateData32422), '</th>');
    }
    output.append('</tr></thead><tbody>');
    var userList32428 = stat_recordData32416.rows;
    var userListLen32428 = userList32428.length;
    for (var userIndex32428 = 0; userIndex32428 < userListLen32428; userIndex32428++) {
      var userData32428 = userList32428[userIndex32428];
      output.append('<tr><td></td><td>', soy.$$escapeHtml(userData32428.username), '</td>');
      var valueList32432 = userData32428.values;
      var valueListLen32432 = valueList32432.length;
      for (var valueIndex32432 = 0; valueIndex32432 < valueListLen32432; valueIndex32432++) {
        var valueData32432 = valueList32432[valueIndex32432];
        output.append('<td>', soy.$$escapeHtml(valueData32432 ? valueData32432 : '-'), '</td>');
      }
      output.append('</tr>');
    }
    output.append('</tbody></table></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.stats.reports.systemHealth = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="row"><div class="span12"><h4>User Activity</h4><table class="table table-striped table-condensed"><thead><tr><th></th>');
  var dateList32443 = opt_data.data.dates;
  var dateListLen32443 = dateList32443.length;
  for (var dateIndex32443 = 0; dateIndex32443 < dateListLen32443; dateIndex32443++) {
    var dateData32443 = dateList32443[dateIndex32443];
    output.append('<th>', soy.$$escapeHtml(dateData32443), '</th>');
  }
  output.append('</tr></thead><tbody>');
  var stat_recordList32449 = opt_data.data.activity_stats;
  var stat_recordListLen32449 = stat_recordList32449.length;
  for (var stat_recordIndex32449 = 0; stat_recordIndex32449 < stat_recordListLen32449; stat_recordIndex32449++) {
    var stat_recordData32449 = stat_recordList32449[stat_recordIndex32449];
    output.append('<tr><td>', soy.$$escapeHtml(stat_recordData32449.stat), '</td>');
    var valueList32453 = stat_recordData32449.values;
    var valueListLen32453 = valueList32453.length;
    for (var valueIndex32453 = 0; valueIndex32453 < valueListLen32453; valueIndex32453++) {
      var valueData32453 = valueList32453[valueIndex32453];
      output.append('<td>', soy.$$escapeHtml(valueData32453 ? valueData32453 : '-'), '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div><div class="row"><div class="span12"><h4>Patient Population</h4><table class="table table-striped table-condensed"><thead><tr><th></th>');
  var dateList32461 = opt_data.data.dates;
  var dateListLen32461 = dateList32461.length;
  for (var dateIndex32461 = 0; dateIndex32461 < dateListLen32461; dateIndex32461++) {
    var dateData32461 = dateList32461[dateIndex32461];
    output.append('<th>', soy.$$escapeHtml(dateData32461), '</th>');
  }
  output.append('</tr></thead><tbody>');
  var stat_recordList32467 = opt_data.data.population_stats;
  var stat_recordListLen32467 = stat_recordList32467.length;
  for (var stat_recordIndex32467 = 0; stat_recordIndex32467 < stat_recordListLen32467; stat_recordIndex32467++) {
    var stat_recordData32467 = stat_recordList32467[stat_recordIndex32467];
    output.append('<tr><td>', soy.$$escapeHtml(stat_recordData32467.stat), '</td>');
    var valueList32471 = stat_recordData32467.values;
    var valueListLen32471 = valueList32471.length;
    for (var valueIndex32471 = 0; valueIndex32471 < valueListLen32471; valueIndex32471++) {
      var valueData32471 = valueList32471[valueIndex32471];
      output.append('<td>', soy.$$escapeHtml(valueData32471 ? valueData32471 : '-'), '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div><div class="row"><div class="span12"><h4>Interface Volume</h4><table class="table table-striped table-condensed"><thead><tr><th></th>');
  var dateList32479 = opt_data.data.dates;
  var dateListLen32479 = dateList32479.length;
  for (var dateIndex32479 = 0; dateIndex32479 < dateListLen32479; dateIndex32479++) {
    var dateData32479 = dateList32479[dateIndex32479];
    output.append('<th>', soy.$$escapeHtml(dateData32479), '</th>');
  }
  output.append('</tr></thead><tbody>');
  var stat_recordList32485 = opt_data.data.interface_stats;
  var stat_recordListLen32485 = stat_recordList32485.length;
  for (var stat_recordIndex32485 = 0; stat_recordIndex32485 < stat_recordListLen32485; stat_recordIndex32485++) {
    var stat_recordData32485 = stat_recordList32485[stat_recordIndex32485];
    output.append('<tr><td>', soy.$$escapeHtml(stat_recordData32485.stat), '</td>');
    var valueList32489 = stat_recordData32485.values;
    var valueListLen32489 = valueList32489.length;
    for (var valueIndex32489 = 0; valueIndex32489 < valueListLen32489; valueIndex32489++) {
      var valueData32489 = valueList32489[valueIndex32489];
      output.append('<td>', soy.$$escapeHtml(valueData32489 ? valueData32489 : '-'), '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div><div class="row"><div class="span12"><h4>Performance</h4><table class="table table-striped table-condensed"><thead><tr><th></th>');
  var dateList32497 = opt_data.data.dates;
  var dateListLen32497 = dateList32497.length;
  for (var dateIndex32497 = 0; dateIndex32497 < dateListLen32497; dateIndex32497++) {
    var dateData32497 = dateList32497[dateIndex32497];
    output.append('<th>', soy.$$escapeHtml(dateData32497), '</th>');
  }
  output.append('</tr></thead><tbody>');
  var stat_recordList32503 = opt_data.data.performance_stats;
  var stat_recordListLen32503 = stat_recordList32503.length;
  for (var stat_recordIndex32503 = 0; stat_recordIndex32503 < stat_recordListLen32503; stat_recordIndex32503++) {
    var stat_recordData32503 = stat_recordList32503[stat_recordIndex32503];
    output.append('<tr><td>', soy.$$escapeHtml(stat_recordData32503.stat), '</td>');
    var valueList32507 = stat_recordData32503.values;
    var valueListLen32507 = valueList32507.length;
    for (var valueIndex32507 = 0; valueIndex32507 < valueListLen32507; valueIndex32507++) {
      var valueData32507 = valueList32507[valueIndex32507];
      output.append('<td>', soy.$$escapeHtml(valueData32507 ? valueData32507 : '-'), '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div><div class="row"><div class="span12"><h4>Errors</h4><table class="table table-striped table-condensed"><thead><tr><th></th>');
  var dateList32515 = opt_data.data.dates;
  var dateListLen32515 = dateList32515.length;
  for (var dateIndex32515 = 0; dateIndex32515 < dateListLen32515; dateIndex32515++) {
    var dateData32515 = dateList32515[dateIndex32515];
    output.append('<th>', soy.$$escapeHtml(dateData32515), '</th>');
  }
  output.append('</tr></thead><tbody>');
  var stat_recordList32521 = opt_data.data.issues_stats;
  var stat_recordListLen32521 = stat_recordList32521.length;
  for (var stat_recordIndex32521 = 0; stat_recordIndex32521 < stat_recordListLen32521; stat_recordIndex32521++) {
    var stat_recordData32521 = stat_recordList32521[stat_recordIndex32521];
    output.append('<tr><td>', soy.$$escapeHtml(stat_recordData32521.stat), '</td>');
    var valueList32525 = stat_recordData32521.values;
    var valueListLen32525 = valueList32525.length;
    for (var valueIndex32525 = 0; valueIndex32525 < valueListLen32525; valueIndex32525++) {
      var valueData32525 = valueList32525[valueIndex32525];
      output.append('<td>', soy.$$escapeHtml(valueData32525 ? valueData32525 : '-'), '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div>');
  if (!opt_sb) return output.toString();
};
